// extracted by mini-css-extract-plugin
module.exports = {"termsBackground":"Terms_termsBackground__240TD"};